import { BaseURL } from "../service/Api";

// Debug/test payment affordances (e.g. $0.01 test amounts) should be visible
// on localhost and staging, but never on production.
export const isDebugEnvironment = () =>
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    BaseURL.includes("staging.muzukuru.com"));
